import { render, staticRenderFns } from "./HubHeader.vue?vue&type=template&id=1f5b70d8&scoped=true&"
import script from "./HubHeader.vue?vue&type=script&lang=js&"
export * from "./HubHeader.vue?vue&type=script&lang=js&"
import style0 from "./HubHeader.vue?vue&type=style&index=0&id=1f5b70d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5b70d8",
  null
  
)

export default component.exports